import { render, staticRenderFns } from "./MediumBusinessPlanDescription.vue?vue&type=template&id=bcc11a40&scoped=true&"
import script from "./MediumBusinessPlanDescription.vue?vue&type=script&lang=js&"
export * from "./MediumBusinessPlanDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc11a40",
  null
  
)

export default component.exports